<template>
  <div>
    <h3>
      These tools will help you to monitor and manage conversions, choose the
      best creatives and traffic for it.
    </h3>
    <el-container class="tracker">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-card class="box-card">
            <p>
              Using pixel, the visitor's browser will send automatically the
              information of the conversion without any additional
              participation.
            </p>
            <p>Your Pixel will be like this:</p>
            <el-input v-model="pixelValue" type="textarea" />
            <p>
              “c=“ could be from 1 to 10 (place pixel on your landing and
              conversion pages with different “c=“. Insert this code at the top
              of body section of your conversion page.
            </p>
          </el-card>
        </el-col>
      </el-row>
    </el-container>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useUserStore } from '@/store/modules/user'

import { PA4KA_DOMAIN } from '@/apps/traforama/constants'

export default defineComponent({
  name: 'ConversionTracker',
  setup(_props, context) {
    const userStore = useUserStore()
    const pixelValue = `<img src="https://${PA4KA_DOMAIN}/c.png?suid=${userStore.suid}&c=1" width="1" height="1">`
    return { pixelValue }
  }
})
</script>
<style type="text/css">
.tracker .el-card__header {
  padding: 0 18px;
}
</style>
